import React from "react";
import { Router } from "react-router-dom";
import history from "./../services/history";
import CustomRoutes from "./../routes";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

// import {ConnectedRouter} from "react-router-redux";
import { Provider, useSelector } from "react-redux";
import configureStore from "../redux/store/index";
import { createTheme, ThemeProvider } from "@mui/material";
import { PersistGate } from "redux-persist/integration/react";
import "../static/css/wms.css";

export const store = configureStore();

function App() {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Provider store={store.store}>
        <PersistGate persistor={store.persistor}>
          <Router history={history}>
            <CustomRoutes />
            {/* <ThemeProvider theme={appFont}>
          </ThemeProvider> */}
          </Router>
        </PersistGate>
      </Provider>
    </LocalizationProvider>
  );
}
export default App;
